import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Slide,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Switch,
} from "@mui/material";
import { purple } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import ExpandMoreIcon from "@mui/icons-material/";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import useLocalStorage from "../hooks/useLocalStorage";
import { Grid } from "@mui/joy";
import TablaNotas from "../Components/TablaNotas";
import EditIcon from "@mui/icons-material/Edit";
const initialMateria = [
  {
    id: 1,
    materia: "Anlisis Matematico",
    sigla: "E10202",
    totalPonderados: 3,
    color: "red",
    modalidad: "Anual",
    auxiliaturas: true,
    calificaciones: {
      asistencia: 0,
      practicas: 0,
      auxiliaturas: 0,
      parcial1: 0,
      parcial2: 0,
      parcial3: 0,
      final: 0,
    },
  },
];
const initialForm = {
  id: null,
  materia: "",
  sigla: "",
  totalPonderados: 3,
  color: "#7b1fa2",
  modalidad: "Anual",
  auxiliaturas: false,
  calificaciones: {
    asistencia: 0,
    practicas: 0,
    auxiliaturas: 0,
    parcial1: 0,
    parcial2: 0,
    parcial3: 0,
    final: 0,
  },
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PonderadosPues() {
  //   const [materias, setMaterias] = useState();
  const [materias, setMaterias] = useLocalStorage(
    "materias",
    initialMateria
  );
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [expanded, setExpanded] = useState(false);
  const [form, setForm] = useState(initialForm);

  // Función para actualizar el estado del formulario
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSubmit = () => {
    // console.log("Materia guardada:", form);
    if (form.id === null) {
      const randomNum = Math.floor(Math.random() * 1000000);
      let id = String(randomNum).padStart(6, "0");
      // Aquí puedes agregar la lógica para guardar la materia en tu estado o API
      // Limpiar el formulario
      setMaterias([...materias, { ...form, id }]);
    } else {
      setMaterias((materia) =>
        materia.map((item) =>
          item.id === form.id ? { ...item, ...form } : item
        )
      );
    }

    // ID radom

    // Cerrar el modal
    setModalOpen(false);
  };

  const handleDelete = () => {
    setMaterias((materia) =>
      materia.filter((item) => item.id !== form.id)
    );
    setModalDeleteOpen(false);
  };
  const handleEditItem = (id, updatedData) => {
    setMaterias((materia) =>
      materia.map((item) =>
        item.id === id ? { ...item, ...updatedData } : item
      )
    );
  };
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[700],
    "&:hover": {
      backgroundColor: purple[500],
    },
  }));

  return (
    <div className="p-2 text-center">
      <div>
        <Typography
          variant="h5"
          className="app-title text-title1 text-whit"
        >
          Ponderados Pues
        </Typography>

        {materias.map((el) => (
          <Accordion
            expanded={expanded === el.id}
            onChange={handleChange(el.id)}
            // square={true}
          >
            <AccordionSummary
              expandIcon={<ExpandCircleDownIcon />}
              aria-controls={`${el.id}panel1bh-content`}
              id={`${el.id}panel1bh-header`}
              // style={{ border: "2px", borderColor: "red" }}
            >
              <Typography
                component="span"
                sx={{
                  width: "70%",
                  flexShrink: 0,
                  color: el.color,
                  fontWeight: "500",
                }}
              >
                <b>{el.sigla}: </b>
                {el.materia}
              </Typography>

              <Typography
                component="span"
                sx={{
                  width: "30%",
                  color: "text.secondary",
                  paddingRight: "5px",
                  textAlign: "right",
                }}
              >
                Tot.:{el.totalPonderados.toFixed(2)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: "1px" }}>
              <TablaNotas
                materia={el}
                setMateria={(data) => {
                  handleEditItem(el.id, data);
                }}
              />
              <Box
                sx={{
                  // textAlign: "rich",
                  padding: "4px",
                }}
                align="right"
              >
                <Button
                  variant="outlined"
                  color="warning"
                  sx={{ marginRight: "3px" }}
                  onClick={() => {
                    setForm(el);
                    setModalOpen(true);
                  }}
                >
                  Editar
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setForm(el);
                    setModalDeleteOpen(true);
                  }}
                >
                  Eliminar
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>

      {/* Botón para abrir el modal */}
      <IconButton
        onClick={() => setModalOpen(true)}
        sx={{
          color: "#643cba", // Color morado oscuro
          "&:hover": {
            color: "#3b2169", // Más oscuro al pasar el mouse
          },
        }}
      >
        <AddCircleOutlineIcon sx={{ fontSize: "40px" }} />
      </IconButton>

      {/* Modal de Material-UI */}
      <Dialog
        open={modalOpen}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => setModalOpen(false)}
        TransitionComponent={Transition}
      >
        <DialogTitle>
          {form.id === null ? "Agregar" : "Editar"} Materia
        </DialogTitle>
        <DialogContent style={{ paddingTop: "5px" }}>
          {/* Campo de texto para el nombre de la materia */}
          <TextField
            label="Nombre de la materia"
            variant="outlined"
            fullWidth
            margin="materia"
            name="materia"
            value={form.materia}
            onChange={handleInputChange}
          />

          {/* Sigla y Color en la misma línea */}
          <Grid container spacing={2} sx={{ marginTop: 1 }}>
            <Grid item xs={8}>
              <TextField
                label="Sigla de la materia"
                variant="outlined"
                fullWidth
                name="sigla"
                value={form.sigla}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                {/* <InputLabel sx={{ marginTop: 2 }}>Color de la materia</InputLabel> */}
                <InputLabel
                  style={{
                    marginTop: "-28px",
                    color: "black",
                    width: "100%",
                    // background: "red",
                    textAlign: "Center",
                  }}
                >
                  Color
                </InputLabel>
                {/* <label for="">sdf</label> */}
                <input
                  type="color"
                  name="color"
                  value={form.color}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    height: "40px",
                    marginTop: "10px",
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>

          {/* Tipo de materia y Cuenta con auxiliar en la misma línea */}
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item lg={8} xs={6}>
              <FormControl fullWidth>
                <InputLabel>Modalidad</InputLabel>
                <Select
                  name="modalidad"
                  defaultValue={form.modalidad}
                  onChange={handleInputChange}
                  label="Tipo de materia"
                >
                  <MenuItem value="Anual" selected>
                    Anual
                  </MenuItem>
                  <MenuItem value="Semestral">Semestral</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={4} xs={6}>
              <InputLabel>¿Tiene auxiliar?</InputLabel>
              <FormControlLabel
                control={
                  <Switch
                    name="auxiliaturas"
                    checked={form.auxiliaturas}
                    onChange={handleInputChange}
                  />
                }
                label={` ${form.auxiliaturas ? "Sí" : "No"}`}
                // label={form.hasAssistant ? "Sí" : "No"}
                labelPlacement="start"
                color="secondary"
                sx={
                  {
                    // justifyContent: "space-between",
                    // width: "100%",
                  }
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* Botón para cancelar */}
          <Button
            variant="outlined"
            onClick={() => {
              setModalOpen(false);
              setForm(initialForm);
            }}
            color="secondary"
          >
            Cancelar
          </Button>

          {/* Botón para guardar */}
          <ColorButton variant="contained" onClick={handleSubmit}>
            {form.id === null ? "Guardar" : "Actualizar"}
          </ColorButton>
        </DialogActions>
      </Dialog>
      {/* Modal de Delete */}
      <Dialog
        open={modalDeleteOpen}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => setModalDeleteOpen(false)}
        TransitionComponent={Transition}
      >
        <DialogTitle color="error">Eliminar Materia</DialogTitle>
        <DialogContent style={{ paddingTop: "5px" }}>
          <Typography>
            ¿Esta seguro de eliminar{" "}
            <span style={{ color: form.color }} className="fw-bold">
              {form.materia}
            </span>
            ? los datos se eliminaran definitivamente.
          </Typography>
        </DialogContent>
        <DialogActions>
          {/* Botón para cancelar */}
          <Button
            variant="outlined"
            onClick={() => {
              setModalDeleteOpen(false);
              setForm(initialForm);
            }}
            color="secondary"
          >
            Cancelar
          </Button>

          {/* Botón para guardar */}
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
